import { Box } from '@mui/material';

import { ScoreType } from '@/domain/impact/impact.entity';
import { GaugeScore } from '@/ui/components/score-bars/GaugeScore';
import { ColorsScore } from '@/ui/theme/colors-score';

import { TopicScoreDetailsData } from '../type';
import { ScoreBars } from './ScoreBars';

const FIXED_HEIGHT_GRAPHIC = 190;

export function GraphicWithValueAndRefValue({
  type,
  data,
}: {
  type: ScoreType;
  data: TopicScoreDetailsData;
}) {
  const graphicComponent = getGraphicFromType(type, data);
  return (
    <>
      <Box
        sx={{
          minHeight: FIXED_HEIGHT_GRAPHIC,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {graphicComponent}
      </Box>
    </>
  );
}

function getGraphicFromType(type: ScoreType, data: TopicScoreDetailsData) {
  if (type === 'co2') {
    return (
      <ScoreBars
        value={data?.value}
        refValue={data?.refValue || 0}
        colors={ColorsScore.none}
      />
    );
  }
  // ess + env
  else {
    return <GaugeScore score={data.value} maxScore={data.maxValue} />;
  }
}
